
export default function NoPage() {
    return (
        <div className="error">
        <title>ERROR</title>
        <h2 id="error-notice">error</h2>
        </div>
    )
}